import React, { useState, useEffect } from "react";
import { Autocomplete, TextField } from "@mui/material";

const PromoIndex = ({
  data,
  getData,
  setPromoIndex,
  promoIndex,
  setPage,
  width,
}) => {
  const [selectedValue, setSelectedValue] = useState(promoIndex);

  useEffect(() => {
    if (selectedValue) {
      getData(1);
      setPage(1);
    }
  }, [selectedValue]);

  return (
    <Autocomplete
      options={data}
      size="small"
      getOptionLabel={(option) => option.promo_index || ""}
      value={data.find((item) => item.promo_index === selectedValue) || null}
      onChange={(event, newValue) => {
        const selectedIndex = newValue ? newValue.promo_index : "";
        setPromoIndex(selectedIndex);
        setSelectedValue(selectedIndex);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Select Promo Index"
          variant="outlined"
          style={{
            width: "200px",
            height: "40px",
            marginRight: "10px",
          }}
        />
      )}
    />
  );
};

export default PromoIndex;
